import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import { useClaimJobEdit } from './ClaimEdit.Job.Hooks';

export default function ClaimEditJobSubmitButton() {
  const { form } = useClaimJobEdit();
  const { lang } = getLocales();

  return (
    <Button
      onClick={form.submit}
      media={<Icon class="fas-save" />}
      render={lang.saveJobTable}
      active={!form.hasErrors && form.isUpdated}
      disabled={form.hasErrors || !form.isUpdated}
      isLoading={form.isSubmitted}
      class={ThemeButtonCircle}
      htmlElementProps={{ title: lang.saveJobTable }}
    />
  );
}
